/* ZED homepage, Ines's "Clip In" with Dale's "Meet the three" (79_). New file, not part of Athens.
   Every zed-home section links this file; the guard below makes it run once.
   1. Battery picker: the hero's Milwaukee / Makita / DeWALT battery buttons (and any All / brand chips) set data-zh-bt on <html> (the CSS does the rest),
      keep every chip set in step, point product links at that brand's variant and remember the pick on this device.
   2. Hero: scales the 358x268 stage to its box; pause button; hides the button once the run has stopped.
   3. Sub-nav (990+): sits under the theme's sticky header and marks the panel in view; anchor jumps clear the header.
   4. Panel loops: play only while at least half in view, one at a time, poster first.
      Reduced motion or Save-Data: nothing plays until the visitor presses play.
   5. Reels (Where it goes, Made by the crew): never autoplay. On a mouse, hover plays; the button plays and pauses.
      One at a time, always muted, nothing downloads until a reel is started.
   6. Snap rows (phone): arrows and a counter.
   The theme editor re-runs init on section load. */
(function () {
  'use strict';
  if (window.ZedHome) return;
  var ZH = (window.ZedHome = {});

  var KEY = 'zed-home-battery';
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var mqHover = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : { matches: false };
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  function calm() { return mqReduce.matches || saveData; }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function once(el, key) { if (el.getAttribute('data-zh-ready-' + key)) return false; el.setAttribute('data-zh-ready-' + key, '1'); return true; }
  function raf(fn) { var t = 0; return function () { if (!t) t = window.requestAnimationFrame(function () { t = 0; fn(); }); }; }

  /* ---------------------------------------------------------------- 1. Battery picker */
  var bt = 'a';
  function readBt() {
    try { var v = window.localStorage.getItem(KEY); return /^[mkd]$/.test(v || '') ? v : 'a'; } catch (e) { return 'a'; }
  }
  function saveBt(v) {
    try { if (v === 'a') window.localStorage.removeItem(KEY); else window.localStorage.setItem(KEY, v); } catch (e) { /* private mode */ }
  }
  function applyBt(v, root, announce) {
    root = root || document;
    bt = /^[mkd]$/.test(v) ? v : 'a';
    var html = document.documentElement;
    if (bt === 'a') html.removeAttribute('data-zh-bt'); else html.setAttribute('data-zh-bt', bt);
    $$(root, '[data-zh-chip]').forEach(function (c) {
      c.setAttribute('aria-pressed', c.getAttribute('data-zh-chip') === bt ? 'true' : 'false');
    });
    $$(root, '[data-zh-plink]').forEach(function (a) {
      var base = a.getAttribute('data-zh-plink');
      if (!base) return;
      var id = bt === 'a' ? '' : a.getAttribute('data-zh-v-' + bt);
      a.setAttribute('href', id ? base + (base.indexOf('?') > -1 ? '&' : '?') + 'variant=' + id : base);
    });
    $$(root, '[data-zh-status]').forEach(function (p) {
      var t = p.getAttribute('data-zh-status-' + bt);
      if (t && (announce || p.textContent !== t)) p.textContent = t;
    });
  }
  document.addEventListener('click', function (e) {
    var c = e.target && e.target.closest ? e.target.closest('[data-zh-chip]') : null;
    if (!c) return;
    var v = c.getAttribute('data-zh-chip');
    // Hero battery buttons (data-zh-toggle): a second tap on the picked brand goes back to all three.
    if (v === bt) { if (!c.hasAttribute('data-zh-toggle')) return; v = 'a'; }
    saveBt(v);
    applyBt(v, document, true);
  });

  /* ---------------------------------------------------------------- 2. Hero */
  function initHero(root) {
    if (!once(root, 'hero')) return;
    var fit = root.querySelector('[data-zh-fit]');
    var anim = root.querySelector('[data-zh-anim]');
    var btn = root.querySelector('[data-zh-hero-pause]');
    if (!fit || !anim) return;
    function scale() {
      var w = fit.getBoundingClientRect().width;
      if (w > 0) fit.style.setProperty('--zh-s', (w / 358).toFixed(4));
    }
    scale();
    if ('ResizeObserver' in window) new ResizeObserver(scale).observe(fit);
    else window.addEventListener('resize', scale);
    if (!btn) return;
    if (mqReduce.matches) { btn.hidden = true; return; }
    btn.addEventListener('click', function () {
      var paused = btn.getAttribute('aria-pressed') !== 'true';
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', paused ? 'Play animation' : 'Pause animation');
      anim.classList.toggle('is-paused', paused);
    });
    // zh-dip runs on every frame whatever brand is picked, and ends with the run (21 s).
    anim.addEventListener('animationend', function (e) {
      if (e.animationName === 'zh-dip') btn.hidden = true;
    });
  }

  /* ---------------------------------------------------------------- 3. Sub-nav */
  var HEAD_SEL = '.shopify-section-group-header-group, sticky-header, .header-wrapper, #shopify-section-header';
  function headerBottom() {
    var b = 0;
    $$(document, HEAD_SEL).forEach(function (el) {
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      if (cs.visibility === 'hidden' || cs.display === 'none') return;
      // Where it sits once stuck (its top offset plus its height), so anchor jumps from the top of the page clear it too.
      var r = el.getBoundingClientRect();
      var top = parseFloat(cs.top);
      var end = (isNaN(top) ? 0 : top) + r.height;
      if (r.height > 0 && r.height < window.innerHeight / 2 && end > b) b = end;
    });
    return Math.max(0, Math.round(b));
  }
  // The theme header is sticky: its height feeds --zh-hdr on <html>, used for the sub-nav's top and anchor offsets.
  var hdrLast = -1;
  function placeHdr() {
    var b = headerBottom();
    if (b !== hdrLast) { document.documentElement.style.setProperty('--zh-hdr', b + 'px'); hdrLast = b; }
  }
  var onHdr = raf(placeHdr);
  window.addEventListener('scroll', onHdr, { passive: true });
  window.addEventListener('resize', onHdr);

  function initSub(root) {
    if (!once(root, 'sub')) return;
    var sub = root.querySelector('[data-zh-sub]');
    if (!sub || !('IntersectionObserver' in window)) return;
    var links = $$(sub, 'a[href^="#"]');
    var map = {};
    links.forEach(function (a) {
      var id = decodeURIComponent(a.getAttribute('href').slice(1));
      var el = id && document.getElementById(id);
      if (el) map[id] = a;
    });
    var seen = {};
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { seen[e.target.id] = e.isIntersecting; });
      var cur = null;
      $$(root, '.zh-pan[id]').forEach(function (p) { if (!cur && seen[p.id]) cur = p.id; });
      links.forEach(function (a) {
        if (map[cur] === a) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    Object.keys(map).forEach(function (id) { spy.observe(document.getElementById(id)); });
  }

  /* ---------------------------------------------------------------- 4. Panel loops */
  var loops = [];
  var io = null;
  var posterIo = null;

  function playing(v) { return !v.paused && !v.ended; }
  function setBtn(st, paused) { if (st.btn) st.btn.setAttribute('aria-pressed', paused ? 'true' : 'false'); }
  function loadPoster(st) {
    var p = st.v.getAttribute('data-poster');
    if (p && !st.v.getAttribute('poster')) st.v.setAttribute('poster', p);
  }
  function start(st) {
    loadPoster(st);
    loops.forEach(function (o) { if (o !== st && playing(o.v)) o.v.pause(); });
    var pr = st.v.play();
    if (pr && pr.catch) pr.catch(function () { setBtn(st, true); });
  }
  function choose() {
    // The visitor's own choice wins; otherwise the most visible loop that is at least half in view.
    if (document.hidden) return;
    var pick = null;
    loops.forEach(function (st) {
      if (st.ratio < 0.5) return;
      if (st.user === 'paused') return;
      if (calm() && st.user !== 'play') return;
      if (!pick || (st.user === 'play' && pick.user !== 'play') || (st.user === pick.user && st.ratio > pick.ratio)) pick = st;
    });
    loops.forEach(function (st) { if (st !== pick && playing(st.v)) st.v.pause(); });
    if (pick && !playing(pick.v)) start(pick);
  }
  function initLoop(box) {
    if (!once(box, 'loop')) return;
    var v = box.querySelector('video');
    if (!v) return;
    var st = { box: box, v: v, btn: box.querySelector('[data-zh-loop-pause]'), user: null, ratio: 0 };
    v.muted = true;
    if (calm()) setBtn(st, true);
    v.addEventListener('play', function () { setBtn(st, false); });
    v.addEventListener('pause', function () { if (st.user === 'paused' || calm()) setBtn(st, true); });
    if (st.btn) {
      st.btn.addEventListener('click', function () {
        if (playing(v)) { st.user = 'paused'; v.pause(); setBtn(st, true); }
        else { st.user = 'play'; setBtn(st, false); start(st); }
      });
    }
    loops.push(st);
    if ('IntersectionObserver' in window) {
      if (!io) {
        io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var o = loops.filter(function (x) { return x.box === e.target; })[0];
            if (o) o.ratio = e.isIntersecting ? e.intersectionRatio : 0;
          });
          choose();
        }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
        posterIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            var o = loops.filter(function (x) { return x.box === e.target; })[0];
            if (o) loadPoster(o);
            posterIo.unobserve(e.target);
          });
        }, { rootMargin: '800px 0px' });
      }
      io.observe(box);
      posterIo.observe(box);
    } else {
      loadPoster(st);
    }
  }
  function dropLoops(root) {
    loops = loops.filter(function (st) {
      if (!root.contains(st.box)) return true;
      if (io) io.unobserve(st.box);
      if (posterIo) posterIo.unobserve(st.box);
      st.v.pause();
      return false;
    });
  }

  /* ---------------------------------------------------------------- 5. Reels */
  var players = [];
  function pStop(p) {
    p.v.pause();
    p.hover = false;
    p.el.classList.remove('is-playing');
    p.btn.setAttribute('aria-pressed', 'false');
  }
  function pStart(p, byHover) {
    players.forEach(function (o) { if (o !== p) pStop(o); });
    p.hover = !!byHover;
    p.btn.setAttribute('aria-pressed', 'true');
    if (!p.loaded) {
      p.loaded = true;
      $$(p.v, 'source[data-src]').forEach(function (s) { s.setAttribute('src', s.getAttribute('data-src')); });
      p.v.load();
    }
    p.v.muted = true;
    var pr = p.v.play();
    if (pr && pr.catch) pr.catch(function () { if (p.btn.getAttribute('aria-pressed') === 'true' && p.v.paused) pStop(p); });
  }
  function initPlayer(el) {
    if (!once(el, 'player')) return;
    var v = el.querySelector('video');
    var btn = el.querySelector('[data-zh-play]');
    if (!v || !btn) return;
    var p = { el: el, v: v, btn: btn, hover: false, loaded: false };
    players.push(p);
    v.addEventListener('playing', function () { el.classList.add('is-playing'); });
    v.addEventListener('pause', function () { el.classList.remove('is-playing'); });
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var on = btn.getAttribute('aria-pressed') === 'true';
      if (on && p.hover) { p.hover = false; return; } // a click while hover-playing keeps it playing
      if (on) pStop(p); else pStart(p, false);
    });
    el.addEventListener('mouseenter', function () {
      if (mqHover.matches && btn.getAttribute('aria-pressed') !== 'true') pStart(p, true);
    });
    el.addEventListener('mouseleave', function () {
      if (mqHover.matches && p.hover) pStop(p);
    });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      loops.forEach(function (st) { if (playing(st.v)) st.v.pause(); });
      players.forEach(function (p) { if (playing(p.v)) pStop(p); });
    } else {
      choose();
    }
  });

  /* ---------------------------------------------------------------- 6. Snap rows */
  function initRow(root) {
    if (!once(root, 'row')) return;
    var row = root.querySelector('[data-zh-row]');
    var prev = root.querySelector('[data-zh-prev]');
    var next = root.querySelector('[data-zh-next]');
    var count = root.querySelector('[data-zh-count]');
    if (!row || !prev || !next) return;
    function step() {
      var c = row.firstElementChild;
      if (!c) return 286;
      var gap = parseFloat(window.getComputedStyle(row).columnGap) || 12;
      return c.getBoundingClientRect().width + gap;
    }
    function upd() {
      var max = row.scrollWidth - row.clientWidth - 2;
      prev.setAttribute('aria-disabled', row.scrollLeft <= 2 ? 'true' : 'false');
      next.setAttribute('aria-disabled', row.scrollLeft >= max ? 'true' : 'false');
      if (count) {
        var n = row.children.length;
        var i = row.scrollLeft >= max ? n : Math.min(n, Math.round(row.scrollLeft / step()) + 1);
        count.textContent = String(Math.max(1, i));
      }
    }
    function go(dir, btn) {
      if (btn.getAttribute('aria-disabled') === 'true') return;
      row.scrollBy({ left: dir * step(), behavior: mqReduce.matches ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { go(-1, prev); });
    next.addEventListener('click', function () { go(1, next); });
    row.addEventListener('scroll', raf(upd), { passive: true });
    window.addEventListener('resize', raf(upd));
    upd();
  }

  /* ---------------------------------------------------------------- init */
  function init(root) {
    root = root || document;
    applyBt(root === document ? readBt() : bt, root, false);
    placeHdr();
    $$(root, '[data-zh-hero]').forEach(initHero);
    $$(root, '[data-zh-ad]').forEach(initSub);
    $$(root, '[data-zh-loop]').forEach(initLoop);
    $$(root, '[data-zh-player]').forEach(initPlayer);
    $$(root, '[data-zh-rowwrap]').forEach(initRow);
    choose();
  }
  ZH.init = init;
  ZH.setBattery = function (v) { saveBt(v); applyBt(v, document, true); };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    dropLoops(e.target);
    players = players.filter(function (p) { if (e.target.contains(p.el)) { p.v.pause(); return false; } return true; });
  });
})();
